import { MenuItem } from '@chakra-ui/react'

export default MenuItem
